import {Form, Input, InputNumber, Modal} from "antd";
import React, {useState} from "react";
import * as yup from "yup";
import {useStore} from "../../../../../hooks/useStore";
import {useFormik} from "formik";

export const MinCreditLoadLimitUpdateModal = ({
    visibilityState,
    minCreditLoadLimit = 0,
    onCancel,
    subcompanyId
}) => {
    const stores = useStore();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [visibility, setVisibility] = visibilityState;

    const initialValues = {
        subCompanyId: subcompanyId,
        minCreditLoadLimit
    };

    const [validationSchema, setValidationSchema] = useState(
        yup.object().shape({
            minCreditLoadLimit: yup
                .number()
                .min(0, "Minimum kredi yükleme limiti 0'dan büyük olmalıdır")
        })
    );

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: async values => {
            setConfirmLoading(true);
            try {
                const {minCreditLoadLimit} = values;

                await stores.companyStore.updateMinCreditLoadLimit({
                    subCompanyId: subcompanyId,
                    minCreditLoadLimit: parseInt(minCreditLoadLimit)
                });

                onCancel(true);
            } catch (error) {
                console.error(error);
            } finally {
                setConfirmLoading(false);
                setVisibility(false);
            }
        }
    });

    const {handleSubmit, values, setFieldValue, errors, touched} = formik;

    return (
        <Modal
            title="Minimum Kredi Yükleme Limiti Güncelle"
            visible={visibility}
            onCancel={() => {
                onCancel(false);
                setVisibility(false);
            }}
            onOk={handleSubmit}
            confirmLoading={confirmLoading}
            okText="Kaydet"
            cancelText="İptal"
            okButtonProps={{
                disabled:
                    values.minCreditLoadLimit === undefined ||
                    values.minCreditLoadLimit === "" ||
                    values.minCreditLoadLimit === null
            }}
        >
            <Form>
                <Form.Item
                    validateStatus={
                        errors.minCreditLoadLimit && touched.minCreditLoadLimit
                            ? "error"
                            : "success"
                    }
                    help={
                        errors.minCreditLoadLimit && touched.minCreditLoadLimit
                            ? errors.minCreditLoadLimit
                            : null
                    }
                >
                    <InputNumber
                        style={{width: "100%"}}
                        type="number"
                        name="minCreditLoadLimit"
                        onChange={value => setFieldValue("minCreditLoadLimit", value)}
                        value={values.minCreditLoadLimit}
                        defaultValue={0}
                        min={0}
                        data-testid="minCreditLoadLimitInput"
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};
